import React from 'react';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <section className="w-full bg-navy px-5 py-20 sm:py-24" data-id="element-86" data-mp="vf65316ilxma">
      <div className="mx-auto max-w-2xl text-center" data-id="element-87" data-mp="vgr16v8h9om9">
        <h2 className="font-display text-[1.85rem] font-black leading-tight tracking-tight text-white sm:text-[2.6rem]" data-id="element-88" data-mp="19fgvy47trc7g">
          Smetti di improvvisare.{' '}
          <span className="italic text-ochre" data-id="element-89" data-mp="15fgiomwgp71z">Inizia a insegnare.</span>
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-90" data-mp="1jbah2bzm0e0u">
          Prepara il tuo anno di Arte in un solo giorno.
        </p>
        <div className="mt-8" data-id="element-91" data-mp="1t37wjuxnhs5d">
          <CtaButton label="Voglio Arte Pronta ora" data-id="element-92" data-mp="1t252je5179l8" />
        </div>
      </div>
    </section>;
}